/**
 * 应用中心优惠券设置模块
 */
export const ApplyCouponSettingArr = [
  {
    path: "couponSetting/:id(\\d+)",
    name: "couponSetting/:id(\\d+)",
    meta: {
      title: "优惠券"
    },
    redirect: "/apply/couponSetting/:id(\\d+)/Setting",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "Setting",
        name: "Setting",
        meta: {
          title: "优惠券设置"
        },
        component: () => import("@/views/apply/couponSetting/couponSetting")
      }
    ]
  }
];
